import NProgress from 'nprogress'
import { createMaqariApp } from './createApp'

NProgress.configure({ showSpinner: false })

const { app, router } = createMaqariApp()

router.isReady().then(() => {
  app.mount('#app', true)
})
